module.exports = __webpack_public_path__ + "static/media/so.f285534d.svg";